var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from "../../di/injectable";
var Validator = /** @class */ (function () {
    function Validator() {
    }
    Validator.prototype.valueFrom = function (target) {
        if (target instanceof HTMLInputElement) {
            return target === null || target === void 0 ? void 0 : target.value;
        }
        return target !== null && target !== void 0 ? target : "";
    };
    Validator.prototype.isEmail = function (email) {
        var regix = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regix.test(this.valueFrom(email));
    };
    Validator.prototype.isNumber = function (number) {
        var numeric = parseFloat(this.valueFrom(number));
        return !isNaN(numeric) && isFinite(numeric);
    };
    Validator.prototype.isPhone = function (phone) {
        var regix = /^\+\d{12}$/;
        return regix.test(this.valueFrom(phone));
    };
    Validator.prototype.isEmpty = function (value) {
        return !this.valueFrom(value).trim().length;
    };
    Validator.prototype.isNotEmpty = function (value) {
        return !!this.valueFrom(value).trim().length;
    };
    Validator.prototype.isTooLong = function (value, maxLength) {
        return this.valueFrom(value).length > maxLength;
    };
    Validator.prototype.isTooShort = function (value, minLength) {
        return this.valueFrom(value).length < minLength;
    };
    Validator.prototype.matchLength = function (value, length) {
        return this.valueFrom(value).length === length;
    };
    Validator.prototype.hasSpecialCharacters = function (value) {
        var regix = /[!@#\$%\^\&*\)\(+=._-]/;
        return regix.test(this.valueFrom(value));
    };
    Validator.prototype.hasLowerCase = function (value) {
        var regix = /[a-z]/;
        return regix.test(this.valueFrom(value));
    };
    Validator.prototype.hasUpperCase = function (value) {
        var regix = /[A-Z]/;
        return regix.test(this.valueFrom(value));
    };
    Validator.prototype.hasNumber = function (value) {
        var regix = /[0-9]/;
        return regix.test(this.valueFrom(value));
    };
    Validator = __decorate([
        Injectable()
    ], Validator);
    return Validator;
}());
export { Validator };
//# sourceMappingURL=validator.js.map